export default {
	lang:'th',
	download:{
		"download01":"หน้าต่าง",
		"download02":"แม็ค",
		"download03":"ไอโอเอส",
		"download04":"แอนดรอยด์",
		"download05":"ดาวน์โหลดตอนนี้",
		"download":"ดาวน์โหลด",
		"download2":"มือถือ",
		"download3":"สแกน QR code เพื่อดาวน์โหลด iOS/Android",
		"download4":"รหัส QR",
		"download5":"หน้าต่าง",
		"download6":"รองรับ Windows 10 64 บิตขึ้นไป",
		"download7":"แมคโอเอส",
		"download8":"รองรับ MacOS 10.14 ขึ้นไป",
		"download9":"แอปสโตร์",
		"download10":"รองรับ MacOS 10.14 ขึ้นไป",
		"download11":"แอนดรอยด์",
		"download12":"รองรับ Android 10.14 ขึ้นไป",
	},
	home:{
		"home":"หน้าแรก",
		"XiaobeiBigModel":"โมเดลขนาดเล็ก",
		"AIcapability":"ความสามารถของ AI",
		"Solution":"สารละลาย",
		"ProductCenter":"ศูนย์ผลิตภัณฑ์",
		"MediaCenter":"ศูนย์สื่อ",
		"AboutUs":"เกี่ยวกับเรา",
		"LoginRegis":"เข้าสู่ระบบ/ลงทะเบียน",
		"home1":"ความสามารถหลัก",
		"home2":"สายด่วนบริการลูกค้า",
		"home3":"เบอร์ติดต่อ",
		"home14":"การเสริมพลัง AI โดยใช้ฮาร์ดแวร์อัจฉริยะเป็นตัวพา ช่วยให้มีความสามารถและบริการแบบฟูลสแต็ก",
		"home15":"อัลกอริทึมจิ๊กซอว์",
		"home16":"การจดจำ OCR",
		"home17":"ปัญญาประดิษฐ์",
		"home18":"การจดจำเสียงพูด",
		"home19":"พจนานุกรมที่เชื่อถือได้",
		"home20":"การแปลข้อความ",
		"home21":"การแปลภาพถ่าย",
		"home22":"คำถามและคำตอบทั่วไป",
		"home23":"หลักสูตรวิดีโอ",
		"home24":"Xiaobei AI รุ่นใหญ่",
		"home25":"เทคโนโลยีเป็นพลังการผลิตหลัก",
		"home26":"เจ้าหน้าที่ฝ่ายเทคนิค",
		"home27":"การลงทุนด้านการวิจัยและพัฒนา",
		"home28":"จำนวนสิทธิบัตร",
		"home29":"(เปอร์เซ็นต์)",
		"home30":"(100 ล้านหยวน)",
		"home31":"(รายการ)",
		"home32":"สารละลาย",
		"home33":"เมื่อเผชิญกับความต้องการการใช้งานในสถานการณ์ต่างๆ มากมาย เช่น สำนักงาน การศึกษา และตู้บรรทุกรถยนต์ BeiBo มอบโซลูชั่นแบบครบวงจรให้กับลูกค้าโดยอาศัยความสามารถด้านการวิจัยและพัฒนาและแนวคิดการบริการของตนเอง",
		"home34":"โซลูชั่นที่เกี่ยวข้อง",
		"home35":"ความสามารถของผลิตภัณฑ์ที่เกี่ยวข้อง",
		"home36":"บริการแบบครบวงจร",
		"home37":"การเสริมพลัง AI โดยใช้ฮาร์ดแวร์อัจฉริยะเป็นตัวพา ช่วยให้มีความสามารถและบริการแบบฟูลสแต็ก",
		"home38":"การวิจัยและพัฒนา",
		"home39":"การผลิต",
		"home40":"การจัดการคุณภาพ",
		"home41":"การสนับสนุนหลังการขาย",
		"home42":"ทีมงานวิจัยและพัฒนาซอฟต์แวร์และฮาร์ดแวร์ระดับมืออาชีพ มีประสบการณ์ด้านการ OCR การจดจำเสียง การแปล AI และการโต้ตอบระหว่างมนุษย์กับคอมพิวเตอร์มาอย่างยาวนาน",
		"home43":"โรงงานต้นทาง ห่วงโซ่อุปทานที่มั่นคง กระบวนการผลิตอัจฉริยะที่เข้มงวด",
		"home44":"ผู้ตรวจสอบคุณภาพตรวจสอบทุกขั้นตอนและนำระบบการจัดการ ISO9001 มาใช้",
		"home45":"จัดตั้งทีมสนับสนุนหลังการขายระดับมืออาชีพในประเทศและต่างประเทศเพื่อให้ตอบสนองได้ทันท่วงที มีโซลูชันที่เจาะจง และบริการแบบตัวต่อตัว",
		"home46":"การรับรอง",
		"home47":"สิทธิบัตรทั้งในและต่างประเทศมากกว่า 100 ฉบับ",
		"home48":"ข่าว",
		"home49":"เรียนรู้เกี่ยวกับข่าวสารล่าสุดของเรา",
		"home50":"ตรวจสอบรายละเอียด",
		"home51":"พันธมิตร",
		"home52":"มุ่งเน้นตลาดฮาร์ดแวร์ปัญญาประดิษฐ์และให้บริการ OEM/0DM ระดับมืออาชีพ",
		"home53":"การปรึกษาหารือความร่วมมือ",
		"home54":"สมาร์ทออฟฟิศ",
		"home55":"การศึกษาอัจฉริยะ",
		"home56":"กล่องรถสมาร์ท",
		"home57":"การจดจำเสียงพูด",
		"home58":"อัลกอริทึมจิ๊กซอว์",
		"home59":"การจดจำ OCR",
		"home60":"การสังเคราะห์เสียงพูด",
		"home61":"การแปลข้อความ",
		"home62":"การแปลภาพ",
		"home63":"การแปลเสียง",
		"home64":"การประมวลผลภาษาธรรมชาติ",
		"home571":"การจดจำ OCR",
		"home581":"การจดจำเสียงพูด ",
		"home591":"การแปลเสียง",
		"home601":"การสังเคราะห์เสียงพูด",
		"home611":"พจนานุกรมที่เชื่อถือได้",
		"home621":"หลักสูตรทั่วไป",
		"home631":"คำถามและคำตอบทั่วไป",
		"home641":"การประมวลผลภาษาธรรมชาติ",
		"home572":"การจดจำเสียงพูด",
		"home582":"การสังเคราะห์เสียงพูด ",
		"home592":"การแปลเสียง",
		"home602":"การประมวลผลภาษาธรรมชาติ",
		"home603":"ไม่มีอีกต่อไป",
	},
	consult:{
		"tilte":"เราจะมอบบริการความร่วมมือทางธุรกิจแบบครบวงจรให้กับคุณด้วยความเต็มใจ",
		"subtilte":"กรุณาฝากข้อมูลติดต่อของคุณไว้และเราจะติดต่อกลับโดยเร็วที่สุด",
		"name":"กรุณากรอกชื่อของคุณ",
		"phone":"กรุณากรอกเบอร์โทรศัพท์ของท่าน",
		"mailbox":"กรุณากรอกอีเมล์ของคุณ",
		"mailboxerr":"ข้อผิดพลาดรูปแบบอีเมล",
		"company":"กรุณาระบุบริษัทของคุณ",
		"desc":"กรุณากรอกความต้องการของคุณ",
		"but":"ยืนยันการส่ง",
		"region":"จีน",
		"select":"กรุณาเลือก",
		"submitSuccess":"ส่งเรียบร้อยแล้ว",
		"submitError":"การส่งล้มเหลว",
	},
	ProDetails:{
		"ProDetails1":"กระบวนการปรับแต่ง",
		"ProDetails2":"มุ่งเน้นตลาดฮาร์ดแวร์ปัญญาประดิษฐ์และให้บริการ OEM/0DM ระดับมืออาชีพ",
	},
	aiCapacity:{
		"aiMode1":"ความสามารถของ AI",
		"aiMode2":"โดยอาศัยเทคโนโลยีต่างๆ เช่น บิ๊กดาต้า กราฟความรู้ การเรียนรู้ของเครื่องจักร และภาษาศาสตร์ เรายังคงพัฒนานวัตกรรมและมุ่งเน้นการวิจัยเทคโนโลยีหลักของ AI และการใช้งานแอปพลิเคชันฮาร์ดแวร์อัจฉริยะ",
		"aiMode3":"การปรึกษาหารือความร่วมมือ",
		"aiMode4":"ความสามารถหลัก",
		"aiMode5":"การเสริมพลัง AI โดยใช้ฮาร์ดแวร์อัจฉริยะเป็นตัวพา ช่วยให้มีความสามารถและบริการแบบฟูลสแต็ก",
		"aiMode6":"อัลกอริทึมจิ๊กซอว์",
		"aiMode7":"รวมภาพขนาดเล็กที่กระจัดกระจายเป็นภาพขนาดใหญ่เพื่อการจดจำ รองรับมากกว่า 50 ภาษา",
		"aiMode8":"การจดจำ OCR",
		"aiMode9":"ดึงข้อความผ่านเทคโนโลยีการประมวลผลภาพและการจดจำรูปแบบ รองรับมากกว่า 50 ภาษา",
		"aiMode10":"การจดจำเสียงพูด",
		"aiMode11":"แยกแยะเสียงยาวและสั้นเป็นข้อความได้อย่างแม่นยำ รองรับมากกว่า 130 ภาษา",
		"aiMode12":"การสังเคราะห์เสียงพูด",
		"aiMode13":"แปลงข้อความเป็นเสียงมนุษย์ที่เป็นธรรมชาติและคล่องแคล่ว รองรับมากกว่า 130 ภาษา",
		"aiMode14":"การแปลข้อความ",
		"aiMode15":"แปลงข้อความจากภาษาเป้าหมายเป็นภาษาที่ระบุ รองรับมากกว่า 130 ภาษา",
		"aiMode16":"การแปลภาพ",
		"aiMode17":"การรู้จำและแปลข้อความภาพ รองรับมากกว่า 130 ภาษา",
		"aiMode18":"การแปลเสียง",
		"aiMode19":"จดจำและแปลเสียงยาวและสั้นได้อย่างแม่นยำ รองรับมากกว่า 130 ภาษา",
		"aiMode20":"การประมวลผลภาษาธรรมชาติ",
		"aiMode21":"โดยอาศัยข้อมูลขนาดใหญ่ ความรู้ และเทคโนโลยีภาษา แอปพลิเคชันต่างๆ เช่น การตอบคำถามและการสนทนาสามารถเกิดขึ้นได้จริง",
		"aiMode22":"อำนาจพจนานุกรม",
		"aiMode23":"ร่วมมือกับสถาบันที่มีอำนาจอย่างลึกซึ้งเพื่อจัดหาพจนานุกรมที่แท้จริง เช่น Oxford, Longman และภาษาชนกลุ่มน้อยต่างๆ",
		"aiMode24":"หลักสูตรวิดีโอ",
		"aiMode25":"หลักสูตรวิดีโอเต็มรูปแบบ หนังสือเรียนอัปเดตพร้อมกัน เหมาะสำหรับการดูตัวอย่างและทบทวน",
		"aiMode26":"คำถามและคำตอบทั่วไป",
		"aiMode27":"ตอบคำถามและตีความคำถามในทุกวิชา เรียนรู้โดยการเปรียบเทียบ และปรับปรุงประสิทธิภาพการเรียนรู้",
		"aiMode28":"Xiaobei AI รุ่นใหญ่",
		"aiMode29":"การโต้ตอบแบบหลายโหมด",
		"aiMode30":"การโต้ตอบแบบหลายโหมดข้อความ เสียง และวิดีโอ",
		"aiMode31":"ความสามารถในการเขียนโค้ด",
		"aiMode32":"การสร้างโค้ด การตีความ การดีบัก การทดสอบ",
		"aiMode33":"การสร้างข้อความ",
		"aiMode34":"การจัดทำเรียงความ การตลาด ข่าวประชาสัมพันธ์ ฯลฯ",
		"aiMode35":"การแพทย์ทั่วไป",
		"aiMode36":"การตั้งคำถามและการแก้ปัญหาสำหรับทุกวิชา",
		"aiMode37":"ความเข้าใจภาษา",
		"aiMode38":"การสกัดบทคัดย่อ การตรวจสอบไวยากรณ์ การวิเคราะห์ความรู้สึก",
		"aiMode39":"เรื่องไม่สำคัญ",
		"aiMode40":"ความรู้เกี่ยวกับชีวิต การงาน การแพทย์ และประวัติศาสตร์",
		"aiMode41":"การใช้เหตุผลเชิงตรรกะ",
		"aiMode42":"การคิด วิทยาศาสตร์ การใช้เหตุผลแบบสามัญสำนึก",
		"aiMode43":"หลายภาษา",
		"aiMode44":"รองรับการโต้ตอบในมากกว่า 100 ภาษา",
		"aiMode45":"ข้อได้เปรียบทางเทคนิค",
		"aiMode46":"คลังข้อมูลที่แม่นยำ 200 ล้าน",
		"aiMode47":"ใช้กันอย่างแพร่หลายในสำนักงานอัจฉริยะ การศึกษาอัจฉริยะ กล่องรถอัจฉริยะ",
		"aiMode48":"เทคโนโลยีการทำงานร่วมกันระดับโลก",
		"aiMode49":"ความหน่วงต่ำพิเศษ ปลอดภัยและเสถียร การจัดตารางเวลาอัจฉริยะ ลิงก์เสถียร",
		"aiMode50":"ระบบเข้ารหัสความปลอดภัย",
		"aiMode51":"ระบบเข้ารหัสข้อมูลสี่มิติแบบคลาวด์-ไพพ์-เอนด์-ชั้นนำระดับนานาชาติ การเข้ารหัสแบบกระบวนการเต็มรูปแบบ",
	},
	aiMode:{
		"aiMode1":"ความสามารถของ AI",
		"aiMode2":"โดยอาศัยเทคโนโลยีต่างๆ เช่น บิ๊กดาต้า กราฟความรู้ การเรียนรู้ของเครื่องจักร และภาษาศาสตร์ เรายังคงพัฒนานวัตกรรมและมุ่งเน้นการวิจัยเทคโนโลยีหลักของ AI และการใช้งานแอปพลิเคชันฮาร์ดแวร์อัจฉริยะ",
		"aiMode3":"การปรึกษาหารือความร่วมมือ",
		"aiMode4":"ความสามารถหลัก",
		"aiMode5":"การเสริมพลัง AI โดยใช้ฮาร์ดแวร์อัจฉริยะเป็นตัวพา ช่วยให้มีความสามารถและบริการแบบฟูลสแต็ก",
		"aiMode6":"อัลกอริทึมจิ๊กซอว์",
		"aiMode7":"รวมภาพขนาดเล็กที่กระจัดกระจายเป็นภาพขนาดใหญ่เพื่อการจดจำ รองรับมากกว่า 50 ภาษา",
		"aiMode8":"การจดจำ OCR",
		"aiMode9":"ดึงข้อความผ่านเทคโนโลยีการประมวลผลภาพและการจดจำรูปแบบ รองรับมากกว่า 50 ภาษา",
		"aiMode10":"การจดจำเสียงพูด",
		"aiMode11":"แยกแยะเสียงยาวและสั้นเป็นข้อความได้อย่างแม่นยำ รองรับมากกว่า 130 ภาษา",
		"aiMode12":"การสังเคราะห์เสียงพูด",
		"aiMode13":"แปลงข้อความเป็นเสียงมนุษย์ที่เป็นธรรมชาติและคล่องแคล่ว รองรับมากกว่า 130 ภาษา",
		"aiMode14":"การแปลข้อความ",
		"aiMode15":"แปลงข้อความจากภาษาเป้าหมายเป็นภาษาที่ระบุ รองรับมากกว่า 130 ภาษา",
		"aiMode16":"การแปลภาพ",
		"aiMode17":"การรู้จำและแปลข้อความภาพ รองรับมากกว่า 130 ภาษา",
		"aiMode18":"การแปลเสียง",
		"aiMode19":"จดจำและแปลเสียงยาวและสั้นได้อย่างแม่นยำ รองรับมากกว่า 130 ภาษา",
		"aiMode20":"การประมวลผลภาษาธรรมชาติ",
		"aiMode21":"โดยอาศัยข้อมูลขนาดใหญ่ ความรู้ และเทคโนโลยีภาษา แอปพลิเคชันต่างๆ เช่น การตอบคำถามและการสนทนาสามารถเกิดขึ้นได้จริง",
		"aiMode22":"อำนาจพจนานุกรม",
		"aiMode23":"ร่วมมือกับสถาบันที่มีอำนาจอย่างลึกซึ้งเพื่อจัดหาพจนานุกรมที่แท้จริง เช่น Oxford, Longman และภาษาชนกลุ่มน้อยต่างๆ",
		"aiMode24":"หลักสูตรวิดีโอ",
		"aiMode25":"หลักสูตรวิดีโอเต็มรูปแบบ หนังสือเรียนอัปเดตพร้อมกัน เหมาะสำหรับการดูตัวอย่างและทบทวน",
		"aiMode26":"คำถามและคำตอบทั่วไป",
		"aiMode27":"ตอบคำถามและตีความคำถามในทุกวิชา เรียนรู้โดยการเปรียบเทียบ และปรับปรุงประสิทธิภาพการเรียนรู้",
		"aiMode28":"Xiaobei AI รุ่นใหญ่",
		"aiMode29":"การโต้ตอบแบบหลายโหมด",
		"aiMode30":"การโต้ตอบแบบหลายโหมดข้อความ เสียง และวิดีโอ",
		"aiMode31":"ความสามารถในการเขียนโค้ด",
		"aiMode32":"การสร้างโค้ด การตีความ การดีบัก การทดสอบ",
		"aiMode33":"การสร้างข้อความ",
		"aiMode34":"การเรียบเรียง การตลาด การจัดทำข่าวประชาสัมพันธ์ ฯลฯ",
		"aiMode35":"การแพทย์ทั่วไป",
		"aiMode36":"การตั้งคำถามและการแก้ปัญหาสำหรับทุกวิชา",
		"aiMode37":"ความเข้าใจภาษา",
		"aiMode38":"การสกัดบทคัดย่อ การตรวจสอบไวยากรณ์ การวิเคราะห์ความรู้สึก",
		"aiMode39":"เรื่องไม่สำคัญ",
		"aiMode40":"ความรู้เกี่ยวกับชีวิต การงาน การแพทย์ และประวัติศาสตร์",
	},
	Product:{
		"Product1":"ศูนย์ผลิตภัณฑ์",
		"Product2":"สำนักงาน การศึกษา และผลิตภัณฑ์อัจฉริยะในรถยนต์ รองรับการสั่งซื้อและการปรับแต่งฟังก์ชัน",
		"Product3":"การปรึกษาหารือความร่วมมือ",
	},
	medium:{
		"medium1":"ศูนย์สื่อ",
		"medium2":"ข่าวสารล่าสุดของ BeiBo โปรดดูที่นี่",
		"medium3":"การปรึกษาหารือความร่วมมือ",
	},
	about:{
		"about1":"เรียนรู้เพิ่มเติมเกี่ยวกับ BeiBo",
		"about2":"ผู้ให้บริการโซลูชั่นฮาร์ดแวร์อัจฉริยะสำหรับสำนักงาน การศึกษา ตู้บรรทุกรถยนต์ ฯลฯ",
		"about3":"การปรึกษาหารือความร่วมมือ",
		"about4":"โปรไฟล์บริษัท",
		"about5":"การรับรอง",
		"about6":"สิทธิบัตรทั้งในและต่างประเทศมากกว่า 100 ฉบับ",
		"about7":"บริษัท เซินเจิ้น เบ๋อป๋อ อินเทลลิเจนท์ เทคโนโลยี จำกัด",
		"about8":`BeiBo Intelligent ก่อตั้งขึ้นในปี 2015 และมีสำนักงานใหญ่อยู่ในเซินเจิ้น ซึ่งเป็นศูนย์กลาง "การผลิตอัจฉริยะ" ของจีน โดยเป็นองค์กรด้านเทคโนโลยีขั้นสูงระดับชาติและเป็นองค์กรเฉพาะทางและสร้างสรรค์ที่มีวิสัยทัศน์ที่มองไปข้างหน้าและจิตวิญญาณแห่งนวัตกรรม`,
		"about9":"บริษัทมุ่งเน้นตลาดเฉพาะด้าน AI voice และมีศักยภาพในการวิจัยและพัฒนาซอฟต์แวร์และฮาร์ดแวร์ AI ที่แข็งแกร่ง บริษัทส่งเสริมฮาร์ดแวร์ AI ด้วยการส่งออกเทคโนโลยี AI เช่น AI voice, AI translation, AI OCR, AI human-vehicle interaction และ AI cloud บริษัทพัฒนาโมเดล AI voice translation ของตนเอง ผสานรวมเทคโนโลยี AI multimodal และ AIGC ล่าสุด และนำเสนอโซลูชันเทคโนโลยี AI voice แบบครบวงจรสำหรับลูกค้าในหลากหลายสาขา โดยอิงจากการวิจัยและพัฒนาและการออกแบบแพลตฟอร์มชิปและโซลูชันฮาร์ดแวร์ ในด้านการศึกษา ภาครัฐ รัฐวิสาหกิจ และกองทัพ บริษัทมีโซลูชันอุตสาหกรรมที่ครบวงจร ในด้านผู้บริโภค ยอดขายฮาร์ดแวร์ AI เช่น เครื่องแปลภาษา AI เครื่องบันทึกเสียง AI เครื่องสแกน AI และกล่องใส่รถยนต์ AI เกินกว่าหนึ่งล้านชิ้นต่อปี บริษัทมีพันธมิตรเชิงกลยุทธ์หลายรายในญี่ปุ่น ยุโรป สหรัฐอเมริกา และประเทศและภูมิภาคอื่นๆ เพื่อช่วยให้มนุษย์ก้าวข้ามอุปสรรคทางภาษา และเป็นผู้ให้บริการโซลูชันเทคโนโลยี AI voice ชั้นนำระดับโลก",
		"about10":"",
	},
	footer:{
		"AboutUs":"เกี่ยวกับเรา",
		"CollaborativeConsulting":"การปรึกษาหารือความร่วมมือ",
		"Businesscooperation":"ความร่วมมือทางธุรกิจ",
		"phone":"กรุณากรอกเบอร์โทรศัพท์ของท่าน",
		"phone2":"+86 13660736734",
		"phone3":"hangou@szbbzn.com",
		"tel":"0755 27189290",
		"address":"ห้อง 201 อาคาร F เขตอุตสาหกรรมหยวนเฟิน ชุมชนเถาหยวน ถนนต้าหลาง เขตหลงหัว เซินเจิ้น",
		"copyright":"ลิขสิทธิ์ © Shenzhen Beibo Intelligent Technology Co., Ltd.",
		"icp":"กวางตุ้ง ICP หมายเลข 2024241358-1",
		"footer2":"ยินดีต้อนรับเข้าสู่การลงทะเบียน",
		"footer3":"มีบัญชีอยู่แล้วใช่ไหม?",
		"footer4":"กรุณาเข้าสู่ระบบ",
	},
	login:{
		"login1":"รหัสผ่านเข้าระบบ",
		"login2":"เข้าสู่ระบบ SMS",
		"loginTab3":"เข้าสู่ระบบอีเมล์",
		"login3":"จดหมาย",
		"login4":"รหัสผ่านในการเข้าสู่ระบบ",
		"login5":"เบอร์โทรศัพท์",
		"login6":"กรุณาเลือก",
		"login7":"รหัสยืนยันมือถือ",
		"login8":"เข้าสู่ระบบ",
		"login9":"ลืมรหัสผ่าน",
		"login10":"ลงทะเบียน",
		"login11":"โดยการเข้าสู่ระบบ คุณยอมรับ",
		"login12":"ข้อตกลงการให้บริการ",
		"login13":"นโยบายความเป็นส่วนตัว",
		"login14":"รับ",
		"login15":"จีน",
		"login16":"กรุณากรอกหมายเลขบัญชีของคุณ",
		"login17":"กรุณากรอกรหัสผ่านของคุณ",
		"login18":"เข้าสู่ระบบสำเร็จ!",
		"login19":"กรุณากรอกรหัสยืนยัน!",
		"login20":"ส่งเรียบร้อยแล้ว!",
		"login21":"และ",
		"login22":"คลาวด์ดิสก์บันทึกเสียง",
		"login23":"การเขียนของฉัน",
		"login24":"บทสนทนาของฉัน",
		"login25":"ความปลอดภัยของบัญชี",
		"login26":"ออกจากระบบ",
		"login27":"กู้คืนรหัสผ่านทางอีเมล",
		"login28":"จดหมาย",
		"login29":"รหัสยืนยันอีเมล",
		"login30":"ตั้งรหัสผ่านในการเข้าสู่ระบบ (6-16 ตัวอักษร)",
		"login31":"กรอกรหัสผ่านในการเข้าสู่ระบบอีกครั้ง",
		"login32":"ส่ง",
		"login33":"กลับสู่การเข้าสู่ระบบ",
		"login34":"การแก้ไขสำเร็จแล้ว!",
	},
	register:{
		"register1":"เบอร์โทรศัพท์",
		"register2":"กรุณากรอกเบอร์โทรศัพท์ของท่าน",
		"register3":"กรุณาเลือก",
		"register4":"รหัสยืนยันมือถือ",
		"register5":"ตั้งรหัสผ่าน",
		"register6":"กรุณากรอกรหัสยืนยัน",
		"register7":"6-16 ตัวอักษร",
		"register8":"การยืนยันรหัสผ่าน",
		"register9":"จดหมาย",
		"register10":"กรุณากรอกที่อยู่อีเมล์ของคุณ",
		"register11":"รหัสยืนยันอีเมล",
		"register12":"กรุณากรอกรหัสยืนยัน",
		"register13":"ฉันได้อ่านแล้วและเห็นด้วย",
		"register14":"กรุณาอ่านและทำเครื่องหมายในช่องที่ยอมรับข้อตกลง",
		"register15":"รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง/หมายเลขโทรศัพท์ได้รับการลงทะเบียนแล้ว",
		"register16":"ข้อผิดพลาดรหัสยืนยันมือถือ",
		"register17":"กรุณากรอกที่อยู่อีเมลของคุณ / รูปแบบที่อยู่อีเมลไม่ถูกต้อง",
		"register18":"ข้อผิดพลาดรูปแบบอีเมล",
		"register19":"ข้อผิดพลาดรหัสยืนยันอีเมล",
		"register20":"กรุณาตั้งรหัสผ่านเป็น 6-16 ตัวอักษร",
		"register21":"ข้อผิดพลาดรูปแบบรหัสผ่าน",
		"register22":"รหัสผ่านที่คุณป้อนสองครั้งไม่ตรงกัน กรุณาป้อนใหม่อีกครั้ง",
		"register23":"กรุณากรอกรหัสผ่านของคุณ",
		"register24":"ลงทะเบียนสำเร็จ!",
		"register25":"รหัสตรวจสอบมีข้อผิดพลาด",
	},
	recorder:{
		"recorder1":"คลาวด์ดิสก์บันทึกเสียง",
		"recorder2":"ความจุพื้นที่คลาวด์",
		"recorder3":"เอกสาร",
		"recorder331":"ถังขยะรีไซเคิล",
		"recorder332":"ล้างทั้งหมด",
		"recorder4":"ชื่อ",
		"recorder5":"ระยะเวลาของเสียง",
		"recorder6":"ขนาดไฟล์",
		"recorder7":"เวลาการสร้าง",
		"recorder8":"ดำเนินงาน",
		"recorder9":"คำอธิบายพื้นที่คลาวด์",
		"recorder10":"เอกสาร",
		"recorder11":"ไฟล์ OCR",
		"recorder12":"1. พื้นที่คลาวด์มีไว้ใช้เพื่ออะไร?",
		"recorder13":"หลังจากบันทึกบนเครื่องบันทึกแล้ว คุณสามารถอัปโหลดไฟล์เสียงและไฟล์ถอดเสียงไปยังคลาวด์สเปซได้ แม้ว่าเครื่องบันทึกจะไม่อยู่กับคุณ คุณก็สามารถเข้าถึงคลาวด์สเปซเพื่อดูไฟล์เสียงได้",
		"recorder14":"2. จะอัพโหลดไปยังพื้นที่คลาวด์ได้อย่างไร?",
		"recorder15":"ไปที่ [ไฟล์ของฉัน] บนเครื่องบันทึก เลือกไฟล์เป้าหมายและกดค้างไว้เพื่อแสดงตัวเลือก จากนั้นคลิก อัปโหลด เพื่ออัปโหลดไฟล์ไปยังพื้นที่คลาวด์",
		"recorder16":"3. วิธีการดู/จัดการไฟล์พื้นที่คลาวด์?",
		"recorder17":"เข้าสู่ระบบเว็บไซต์อย่างเป็นทางการของ BeiBo เลือก My-Recorder Cloud Disk แล้วคุณจะสามารถดูไฟล์บันทึกที่อัปโหลดได้ คุณสามารถเลือกไฟล์เป้าหมายที่จะดาวน์โหลด ลบ ฯลฯ คุณสามารถล้างพื้นที่เก็บข้อมูลบนคลาวด์ได้โดยการลบไฟล์พื้นที่คลาวด์!",
		"recorder18":"ไม่ได้ถอดความ",
		"recorder19":"ดูสรุป",
		"recorder20":"ผู้บรรยาย",
		"recorder21":"แก้ไขชื่อผู้พูด",
		"recorder22":"แน่นอน",
		"recorder23":"ดาวน์โหลด",
		"recorder24":"ดาวน์โหลดเนื้อหา:",
		"recorder25":"การตั้งค่าการดาวน์โหลด:",
		"recorder26":"การแสดงของวิทยากร",
		"recorder27":"ยกเลิก",
		"recorder28":"การแชร์ลิงค์",
		"recorder29":"ใครก็ตามที่ได้รับลิงก์นี้สามารถเข้าถึงได้ ลิงก์นี้ใช้สำหรับอ่านเท่านั้น และมีอายุ 7 วัน",
		"recorder30":"คัดลอกลิงค์",
		"recorder31":"สแกนและดูอย่างรวดเร็ว",
		"recorder32":"องค์กรอัจฉริยะ",
		"recorder33":"การแยกความแตกต่างระหว่างลำโพง",
		"recorder34":"แยกแยะข้อความที่ถอดความอย่างชาญฉลาดตามบทบาทของผู้พูด",
		"recorder35":"การปรับมาตรฐานภาษาพูดอัจฉริยะ",
		"recorder36":"กรองอนุภาคโหมด คำที่ซ้ำ และคำที่หยุดชั่วคราวโดยอัตโนมัติ",
		"recorder37":"การกรองเสียงที่ไม่ใช่เสียงพูด",
		"recorder38":"ข้ามเสียงโดยอัตโนมัติโดยไม่มีเสียงหรือเสียงรบกวนระหว่างการเล่น",
		"recorder39":"กรุณาเลือก",
		"recorder40":"เอกสาร",
		"recorder41":"เสียง",
		"recorder42":"เอกสาร + เสียง",
		"recorder43":"คำใบ้",
		"recorder44":"การดำเนินการนี้จะลบไฟล์ คุณต้องการดำเนินการต่อหรือไม่?",
		"recorder441":"การดำเนินการนี้จะลบไฟล์ทั้งหมด คุณต้องการดำเนินการต่อหรือไม่?",
		"recorder45":"แน่นอน",
		"recorder46":"ยกเลิก",
		"recorder47":"ลบสำเร็จแล้ว!",
		"recorder48":"ยังไม่ได้ลบ",
		"recorder49":"ยังไม่มีแท็ก",
		"recorder50":"ประหยัด...",
		"recorder51":"ถังขยะรีไซเคิล",
	},
	personal:{
		"personal1":"การตั้งค่าบัญชี",
		"personal2":"ข้อมูลส่วนตัว",
		"personal3":"อวาตาร์",
		"personal4":"อัพโหลดไฟล์",
		"personal5":"รองรับรูปแบบ JPG, JPEG, GIF, PNG รองรับรูปภาพขนาดไม่เกิน 2M",
		"personal6":"ชื่อเล่น",
		"personal7":"กรุณากรอกชื่อเล่นของคุณ",
		"personal8":"เพศ",
		"personal9":"สุภาพบุรุษ",
		"personal10":"นางสาว",
		"personal11":"ความลับ",
		"personal12":"วันเกิด",
		"personal13":"กรุณาเลือกวันเกิดของคุณ",
		"personal14":"วิชาชีพ",
		"personal15":"กรุณาเลือกอาชีพของคุณ",
		"personal16":"กรุณาระบุอาชีพของคุณ (ไม่บังคับ)",
		"personal17":"ชาติ",
		"personal18":"กรุณาเลือกประเทศของคุณ",
		"personal19":"เก็บ",
		"personal20":"ข้อมูลส่วนตัว",
		"personal21":"ความปลอดภัยของบัญชี",
		"personal22":"รองรับเฉพาะรูปภาพที่มีขนาดไม่เกิน 2 ล้าน",
		"personal23":"อัพโหลดสำเร็จแล้ว!",
		"personal24":"การแก้ไขสำเร็จแล้ว!",
		"personal25":"ความปลอดภัยของบัญชี",
		"personal26":"รหัสผ่านในการเข้าสู่ระบบ",
		"personal27":"ปรับปรุงใหม่",
		"personal28":"อีเมล",
		"personal29":"แทนที่",
		"personal30":"การยกเลิกบัญชี",
		"personal32":"คุณแน่ใจว่าต้องการยกเลิกบัญชีของคุณหรือไม่?",
		"personal33":"หลังจากออกจากระบบ เนื้อหาทั้งหมดในบัญชีของคุณจะถูกล้าง ดังนั้นโปรดดำเนินการด้วยความระมัดระวัง",
		"personal34":"ยกเลิก",
		"personal35":"แน่นอน",
		"personal36":"การตรวจสอบความถูกต้อง",
		"personal37":"เพื่อยืนยันว่าคุณเป็นผู้ดำเนินการนี้ โปรดทำการยืนยันตัวตนผ่านรหัสยืนยันอีเมล",
		"personal38":"จดหมาย",
		"personal39":"รหัสยืนยัน",
		"personal40":"กรุณากรอกรหัสยืนยัน",
		"personal41":"ขั้นตอนต่อไป",
		"personal42":"ตั้งค่ากล่องจดหมายใหม่",
		"personal43":"จดหมาย",
		"personal44":"กรุณากรอกอีเมลใหม่",
		"personal45":"รหัสยืนยัน",
		"personal46":"กรุณากรอกรหัสยืนยัน",
		"personal47":"แน่นอน",
		"personal48":"ตั้งรหัสผ่านเข้าสู่ระบบใหม่",
		"personal49":"รหัสผ่านเข้าสู่ระบบใหม่",
		"personal50":"กรุณากรอกรหัสผ่านใหม่",
		"personal51":"ยืนยันรหัสผ่านใหม่",
		"personal52":"กรุณากรอกรหัสผ่านใหม่อีกครั้ง",
		"personal53":"แน่นอน",
		"personal54":"รับ",
		"personal55":"ข้อผิดพลาดรูปแบบอีเมล",
		"personal56":"การเปลี่ยนสำเร็จแล้ว!",
		"personal57":"กรุณาตั้งรหัสผ่านเป็น 6-16 ตัวอักษร",
		"personal58":"รหัสผ่านที่คุณป้อนสองครั้งไม่ตรงกัน",
		"personal59":"การแก้ไขสำเร็จแล้ว!",
		"personal60":"ออกจากระบบสำเร็จ!",
	}
}